import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

import { apiCallV2 } from "../../utils/api";
import { delay } from "../../utils";
import CustomLoader from "../CustomLoader";

import { CallImpactConversion } from "../../redux/v2/impact/actions";
import { SetUserDetails, CheckRequirementsAndRedirectV2, LoadUserData, LoadFavorites, LoadFinishedWorkoutsIDs } from "../../redux/v2/user/actions";

import toast from "react-hot-toast";
import GoogleIcon from "@mui/icons-material/Google";
import { useGoogleLogin } from "@react-oauth/google";
import CustomButton from "../CustomButton";

import "./style.css";

function CustomGoogleAuth(props) {
    const { authType } = props;

    const [searchParams, setSearchParams] = useSearchParams();
    const offer = searchParams.get("offer");

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const proceedSignup = async (data) => {

        if (props?.hasOwnProperty("proceedSignup")) {
            props?.proceedSignup({
                email_address: data?.email,
                first_name: data?.given_name,
                last_name: data?.family_name,
                auth_provider: "google",
                auth_provider_details: {
                    email_verified: data.email_verified,
                    locale: data.locale,
                    picture: data.picture,
                    user: data.sub,
                },
                medium: "web",
            });
        } else {

            const irclickid = localStorage.getItem("irclickid");

            const res = await apiCallV2("POST", "signup-using-auth-provider", {
                email_address: data?.email,
                first_name: data?.given_name,
                last_name: data?.family_name,
                auth_provider: "google",
                auth_provider_details: {
                    email_verified: data.email_verified,
                    locale: data.locale,
                    picture: data.picture,
                    user: data.sub,
                },
                medium: "web",
            });

            setLoading(false);

            if (res.data.status == 200) {
                props.SetUserDetails({
                    first_name: data.given_name,
                    last_name: data.family_name,
                    user_name: data.email,
                    email_address: data.email,
                });

                if (irclickid) {
                    props.CallImpactConversion(irclickid, res.data.data.access_token, data.email);
                }

                localStorage.setItem("access-token", res.data.data.access_token);
                localStorage.setItem("requirement_status", 0);

                navigate("/personal-info");
            } else if (res.data.status == 409) {
                toast.error(res.data.message);
            } else {
                toast.error("Failed to Register new User");
            }
        }
    };

    const proceedLogin = async (data) => {
        const res = await apiCallV2("POST", "login-using-auth-provider", {
            medium: "web",
            email_address: data.email,
            auth_provider: "google",
            details: {
                email_verified: data.email_verified,
                locale: data.locale,
                picture: data.picture,
                user: data.sub,
            },
        });

        if (res && res.data.status === 200) {
            const requirementStatus = res.data.data.requirement_status;

            localStorage.setItem("access-token", res.data.data.access_token);
            localStorage.setItem("email", res.data.data.email_address);
            localStorage.setItem("username", res.data.data.email_address);
            localStorage.setItem("requirement_status", requirementStatus);
            localStorage.setItem(
                "indi-new-user-details",
                JSON.stringify({
                    name: {
                        first: res.data.data.first_name,
                        last: res.data.data.last_name,
                    },
                })
            );

            props.LoadUserData();
            props.LoadFavorites();
            props.LoadFinishedWorkoutsIDs();

            props.SetUserDetails(res.data.data);

            delay(() => {
                setLoading(false);
            }, 10000);

            if (res.data.data.is_billing_info_present) {
                if (res.data.data.is_survey_done && res.data.data.first_name && res.data.data.last_name) {
                } else {
                    localStorage.setItem("survey_not_done", res.data.data.is_survey_done);
                }
            } else {
                navigate(process.env.PUBLIC_URL + (offer ? `/choose-plan?offer=${offer}` : "/choose-plan"));
            }
            // if (requirementStatus != 0) {
            props.CheckRequirementsAndRedirectV2(navigate);
            // }
        } else {
            setLoading(false);
            toast.error(res.data.message);
        }
    };

    const authenticate = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            setLoading(true);

            const userInfo = await axios.get(process.env.REACT_APP_GOOGLE_CLIENT_AUTH, { headers: { Authorization: `Bearer ${tokenResponse.access_token}` } });

            if (userInfo.status == 200) {
                if (authType == "signup") {
                    proceedSignup(userInfo.data);
                } else if (authType == "signin") {
                    proceedLogin(userInfo.data);
                }
            } else {
                toast.error("Unable to continue Google Authentication");
            }
        },
        onError: (err) => {
            toast.error("Unable to continue Google Authentication");
        },
    });

    return (
        <>
            <CustomButton onClick={props?.onClick || authenticate} className="google-auth-button">
                <GoogleIcon sx={{ color: "#fff" }} />
                {authType == "signin" ? "Login with Google" : "Sign Up with Google"}
            </CustomButton>
            {loading && <CustomLoader loading={loading} />}
        </>
    );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    CallImpactConversion,
    SetUserDetails,
    CheckRequirementsAndRedirectV2,
    LoadUserData,
    LoadFavorites,
    LoadFinishedWorkoutsIDs,
})(CustomGoogleAuth);
